const base = '/auth';

export const authRoutes = {
  index: base,
  login: `${base}/login`,
  signup: `${base}/signup`,
  verify: `${base}/verify`,
  forgotPassword: `${base}/forgot-password`,
  resetPassword: `${base}/reset-password`,
  acceptInvite: `${base}/accept-invite`,
} as const;
